import AdminSzakFelvesz from "../components/admin/admin_szakok/AdminSzakFelvesz";
import AdminSzakTablazat from "../components/admin/admin_szakok/AdminSzakTablazat";

function AdminSzakok() {
  return (
    <div>
      <AdminSzakFelvesz />
      <AdminSzakTablazat />
    </div>
  );
}

export default AdminSzakok;
